@if (discoverFacade.multiOrderStrategies$ | async; as strategies) {
  @if (strategies.length) {
    <div class="d-block d-md-flex flex-wrap justify-content-between gap mb-4">
      @for (strategy of strategies | slice: 0 : 4; track strategy.id) {
        <div class="strategy mb-4 mb-md-0" [routerLink]="url + '/' + strategy.id">
          <div class="zero-text p-base-med truncate">{{ strategy.title }}</div>
          @if (strategy.imageUrl) {
            <img class="image" [src]="imageBase + '/' + strategy.imageUrl" alt="strategy" />
          }
        </div>
      }
    </div>
  }
}
